import { render, staticRenderFns } from "./choice-account.vue?vue&type=template&id=3ca02ed9&"
import script from "./choice-account.vue?vue&type=script&lang=js&"
export * from "./choice-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports